import { useEffect, useState } from "react";
import { useContent } from "@/lib/useContent";
import { Rocket, ArrowRight } from "lucide-react";

function daysUntil(targetDate) {
    if (!targetDate) return null;
    const t = new Date(targetDate + "T00:00:00");
    if (Number.isNaN(t.getTime())) return null;
    const diff = t - new Date();
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export default function MissionBanner() {
    const { data } = useContent("current_mission", { enabled: false });
    const [tick, setTick] = useState(0);

    useEffect(() => {
        const id = setInterval(() => setTick((t) => t + 1), 60 * 60 * 1000); // hourly recompute
        return () => clearInterval(id);
    }, []);

    if (!data?.enabled) return null;

    const days = daysUntil(data.target_date);
    const countdown = days === null
        ? null
        : days > 0
            ? `${days} ${days === 1 ? "day" : "days"} to go`
            : days === 0
                ? "Today"
                : "In progress";

    return (
        <div className="relative w-full border-b border-[var(--sb-brand)] overflow-hidden" style={{background: "linear-gradient(90deg, #142a4d 0%, #1c3860 50%, #142a4d 100%)"}} data-testid="mission-banner">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 lg:py-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6" data-key={tick}>
                <div className="flex items-center gap-3 shrink-0">
                    <Rocket size={16} className="text-[var(--sb-brand)]" />
                    <span className="overline text-[var(--sb-brand)]">{data.overline || "Current Mission"}</span>
                </div>
                <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <span className="font-serif text-base sm:text-lg tracking-wide text-[var(--sb-text)] leading-tight" data-testid="mission-headline">
                        {data.headline}
                    </span>
                    {countdown && (
                        <span className="text-xs sm:text-sm font-mono text-[var(--sb-brand)] uppercase tracking-[0.2em] shrink-0" data-testid="mission-countdown">
                            · {countdown}
                        </span>
                    )}
                </div>
                {data.cta_label && data.cta_url && (
                    <a
                        href={data.cta_url}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-primary text-xs shrink-0"
                        style={{padding: "0.5rem 1.1rem"}}
                        data-testid="mission-cta"
                    >
                        {data.cta_label} <ArrowRight size={14} />
                    </a>
                )}
                {data.cta_label && !data.cta_url && (
                    <span className="text-xs text-[var(--sb-text-muted)] italic shrink-0" data-testid="mission-cta-pending">
                        {data.cta_label} — link coming soon
                    </span>
                )}
            </div>
        </div>
    );
}
